function switchBasedOnScheme(variation, styles) {
  return styles[variation] || '';
}

export default switchBasedOnScheme;
